import React from "react";
import BodyContainer from "../ui/BodyContainer";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import {Toaster} from 'react-hot-toast'

const useStyles = makeStyles((theme) => ({
  gridOccupy: {
    width: "100%",
  },
  root: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
  },
  form: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    flexWrap: "wrap",
    paddingTop: theme.spacing(1.5),
  },
  inputStyles: {
    height: 55,
    width: "100%",
    flex: 1,
    borderRadius: "6px",
    borderWidth: 2,
    borderStyle: "solid",
    paddingLeft: 5,
    marginTop: "10px",
    marginBottom: "20px",
  },
  multi: {
    flex: 1,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    borderWidth: 2,
    borderStyle: "solid",
    marginBottom: "14px",
  },
  borderStadiumCls: {
    border: "1px solid #e3e3e3",
    borderRadius: 10,
    padding: "14px",
  },
  button: {
    marginTop: "1rem",
    backgroundColor: "#74AA2D",
    marginLeft: "0.5rem",
    marginRight: "0.5rem",
    color: "#fff",
    borderRadius: 40,
    padding: "10px 40px",
    marginTop: 60,
    marginBottom: 50,
  },
}));

const events = [
  { value: "Event Type1", label: "Event Type1", id: 1 },
  { value: "Event Type2", label: "Event Type2", id: 2 },
  { value: "Event Type3", label: "Event Type3", id: 3 },
];

const stadiums = [
  { value: "Stadium Type1", label: "Stadium Type1", id: 1 },
  { value: "Stadium Type2", label: "Stadium Type2", id: 2 },
  { value: "Stadium Type3", label: "Stadium Type3", id: 3 },
];

function Payment() {
  const classes = useStyles();
  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <BodyContainer title="Payment">
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <form className={classes.form}>
            <Grid container alignItems="center" justify="center">
              <Grid
                item
                container
                spacing={4}
                xs={12}
                alignItems="center"
                justify="center"
              >
                <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                <Grid item xs={12} sm={12} md={12} lg={5}>
                  <input
                    type="text"
                    className={classes.inputStyles}
                    placeholder="Name"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={5}>
                  <input
                    type="text"
                    className={classes.inputStyles}
                    placeholder="Event"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
              </Grid>
              <Grid
                item
                container
                spacing={4}
                xs={12}
                alignItems="center"
                justify="center"
              >
                <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                <Grid item xs={12} sm={12} md={12} lg={5}>
                  <input
                    type="text"
                    className={classes.inputStyles}
                    placeholder="Box"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={5}>
                  <input
                    type="text"
                    className={classes.inputStyles}
                    placeholder="Seat"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
              </Grid>
              <Grid
                item
                container
                spacing={4}
                xs={12}
                alignItems="center"
                justify="center"
              >
                <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                <Grid item xs={12} sm={12} md={12} lg={5}>
                  <input
                    type="text"
                    className={classes.inputStyles}
                    placeholder="Amount"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={5}></Grid>
                <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
              </Grid>
            </Grid>

            <Button
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Pay
            </Button>
          </form>
        </Paper>
        <Toaster position="top-center"/>
      </Grid>
    </BodyContainer>
  );
}

export default Payment;
